module.exports = __webpack_public_path__ + "static/media/icon-supplies-backscrubber.083d21af.svg";